type RuntimeConfig = {
    backendUrl?: string;
    iceServers?: RTCIceServer[];
};

const DEFAULT_BACKEND_URL = "/pipecat";
const DEFAULT_ICE_SERVERS: RTCIceServer[] = [
    { urls: "stun:stun.l.google.com:19302" },
];

let runtimeConfig: RuntimeConfig = {};

function isStringArray(value: unknown) {
    return Array.isArray(value)
        ? value.every(function (item) {
              return typeof item === "string";
          })
        : false;
}

function isIceServer(value: unknown) {
    if (typeof value !== "object" || value === null) {
        return false;
    }

    const server = value as {
        urls?: unknown;
        username?: unknown;
        credential?: unknown;
    };

    const hasUrls =
        typeof server.urls === "string" || isStringArray(server.urls);
    const hasValidUsername =
        server.username === undefined || typeof server.username === "string";
    const hasValidCredential =
        server.credential === undefined ||
        typeof server.credential === "string";

    return hasUrls && hasValidUsername && hasValidCredential;
}

function normalizeRuntimeConfig(value: unknown) {
    const config: RuntimeConfig = {};

    if (typeof value !== "object" || value === null) {
        return config;
    }

    const record = value as {
        backendUrl?: unknown;
        iceServers?: unknown;
    };

    if (typeof record.backendUrl === "string") {
        config.backendUrl = record.backendUrl;
    }

    if (Array.isArray(record.iceServers)) {
        config.iceServers = record.iceServers.filter(function (server) {
            return isIceServer(server);
        }) as RTCIceServer[];
    }

    return config;
}

function trimTrailingSlash(value: string) {
    return value.replace(/\/+$/, "");
}

export async function loadRuntimeConfig() {
    try {
        const response = await fetch("/runtime-config.json", {
            cache: "no-store",
        });

        if (response.ok) {
            runtimeConfig = normalizeRuntimeConfig(await response.json());
        }
    } catch (err) {
        console.warn("Using default runtime config", err);
    }

    return runtimeConfig;
}

export function getBackendEndpoint() {
    const backendUrl = runtimeConfig.backendUrl || DEFAULT_BACKEND_URL;

    return `${trimTrailingSlash(backendUrl)}/start`;
}

export function getIceServers() {
    const iceServers = runtimeConfig.iceServers;

    return iceServers && iceServers.length > 0
        ? iceServers
        : DEFAULT_ICE_SERVERS;
}
